import { FC, useState } from 'react';
import { Modal, Select } from 'antd';
import AddBodyShape from './addBodyShape';
import BodyShapeList from './BodyShapeList';
import React from 'react';
import { useDispatch } from 'react-redux';
import { loadBodyShape } from './BodyShapeSlice';
import { loadCategory } from './../category/categorySlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { loadProductTypes } from '../ProductType/ProductTypeSlice';
import { loadBodySizes } from '../bodySize/bodySizeSlice';

const BodyShape: FC = () => {

  const BodyShapes = useSelector(
    (state: AppState) => state.BodyShape
  );

  const Cat = useSelector((state: AppState) => state.Category);
  const [cat_array, setCatArray] = useState([{}]);
  const [selected, setSelected] = useState<any>('All')
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, editBodyShape, setEditBodyShape, setList } = React.useContext(CommonContext) as CommonContextType;
  React.useEffect(() => {
    setSelected("All")
  }, [BodyShapes]);

  const onChangeSizeType = (value: any) => {
    setSelected(value)
    setList(toggleFittingSizes(value))
  };
  const toggleFittingSizes = (data: any): any => () => {
    if (data !== 'All') {
      return BodyShapes.BodyShapeArr.filter(item => item.category_id === data);
    } else {
      return BodyShapes.BodyShapeArr;
    }
  }
  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditBodyShape(null)
    setModelChange(false);
  };

  React.useEffect(() => {
    dispatch(loadBodyShape());
    dispatch(loadCategory());
    dispatch(loadProductTypes());
    dispatch(loadBodySizes());
  }, [dispatch]);

  React.useEffect(() => {
    if (Cat.CategoryArr.length > 0) {
      const a = [{ value: 'All', label: 'All' }];
      const b = Cat.CategoryArr.map((el: any) => ({ value: el.id, label: el.category_name }))
      setCatArray([...a, ...b]);

    }
  }, [Cat]);

  return (
    <div className='padding'>
      {contextHolder}
      <h2>Body Shape List
        <Select
          defaultValue="All"
          style={{
            width: 120,
            marginLeft: 15,
          }}
          onChange={onChangeSizeType}
          value={selected}
          options={cat_array}
        />
        <button className='top-button' onClick={showModal}>Create</button>
      </h2>
      <br></br>
      <BodyShapeList />
      <Modal title={editBodyShape?.id ? 'Edit Body Shape' : 'Create Body Shape'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddBodyShape />
      </Modal>
    </div>
  );
};

export default BodyShape;